import { useRef } from "react";
import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';

export default function PeriodoDeContratacion({
    formik,
    data,
    changePeriodo,
    disable
}){
    const contratacionRef = useRef(null);

    return(
        <>
            <style type={'text/css'}>
                {`
                    #contratacion{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #contratacion > .rs-stack{
                        display : block!important;
                    }
                    #contratacion-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #contratacion > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #contratacion-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #contratacion-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #contratacion-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <div ref={contratacionRef} className={'position-relative'}>
                <SelectPicker
                    container={() => contratacionRef.current}
                    label={<div className={'labelSelect ps-1'}>Contratación:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width: '100%'}}
                    menuAutoWidth={false}
                    id={'contratacion'}
                    name={'contratacion'}
                    labelKey={'descripcion'}
                    valueKey={'valor'}
                    value={formik.values.contratacion}
                    onChange={(value) => changePeriodo(value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                    disabled={disable}
                />
            </div>
        </>
    );
}
